import React, { useContext, forwardRef } from 'react';

export default function createContextHelpers(Context, name) {
  const capitalizedName = name.charAt(0).toUpperCase() + name.slice(1);
  const { Provider } = Context;

  function useMethod() {
    return useContext(Context);
  }

  const withMethod = (Component) =>
    forwardRef((props, ref) => {
      const value = useMethod();
      return <Component ref={ref} {...props} {...{ [name]: value }} />;
    });

  return {
    [`${name}Context`]: Context,
    [`${capitalizedName}Provider`]: Provider,
    [`use${capitalizedName}`]: useMethod,
    [`with${capitalizedName}`]: withMethod,
  };
}
